import './loadingModal.scss';

export const LoadingModalService = angular
    .module('app.components.modals.loadingModal', [
        'ngMaterial'
    ]).service('loadingModalService', (
        $mdDialog
    ) => {
        return {
            show,
            hide
        };

        function show() {
            return $mdDialog.show({
                template: `
                    <md-dialog class="loading-modal">
                        <md-progress-circular class="loading-modal__loader" md-mode="indeterminate" md-diameter="35">
                        </md-progress-circular>
                    </md-dialog>
                `,
                parent: angular.element('body'),
                clickOutsideToClose: false
            });
        }

        function hide() {
            return $mdDialog.hide();
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/modals/loadingModal.js